import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  getDeviceInfo() {
    if (!this.isBrowser) {
      return {
        isMobile: false,
        isTablet: false,
        isDesktop: true,
        os: 'server',
        browser: 'server',
        userAgent: 'server'
      };
    }

    const ua = navigator.userAgent;
    const isMobile = /Mobi|Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i.test(ua);
    const isTablet = /Tablet|iPad/i.test(ua) ||
                     (isMobile && window.innerWidth >= 768 && window.innerWidth <= 1024);

    return {
      isMobile,
      isTablet,
      isDesktop: !isMobile && !isTablet,
      os: this.getOS(ua),
      browser: this.getBrowser(ua),
      userAgent: ua
    };
  }

  private getOS(ua: string): string {
    if (ua.includes('Windows')) return 'Windows';
    if (ua.includes('Mac OS')) return 'MacOS';
    if (ua.includes('Linux')) return 'Linux';
    if (ua.includes('Android')) return 'Android';
    if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) return 'iOS';
    return 'Unknown';
  }

  private getBrowser(ua: string): string {
    if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
    if (ua.includes('Edg')) return 'Edge';
    if (ua.includes('Opera') || ua.includes('OPR')) return 'Opera';
    return 'Unknown';
  }

  isMobile(): boolean {
    return this.getDeviceInfo().isMobile;
  }

  isTablet(): boolean {
    return this.getDeviceInfo().isTablet;
  }

  isDesktop(): boolean {
    return this.getDeviceInfo().isDesktop;
  }
}
